module.exports = __webpack_public_path__ + "img/car_20.92e3219e.jpg";